
import { defineComponent, onBeforeMount, reactive } from 'vue'

import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import TableScrollWrapper from '@/common/components/UI/TableScrollWrapper/index.vue'
import TheTable from '@/common/components/UI/TheTable/index.vue'
import Modal from '@/common/components/UI/Modal/index.vue'

import { onec } from '@/core/realisations/onec.realisation'

import { DataState } from '@/core/classes/DataState.class'

import { SdtOrder } from '@/core/types/one_c.types'
import useNotifications from '@/common/composable/useNotifications'
import useAccount from '@/common/composable/useAccount'

export const SdtColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Номер заказа',
        key: 'foreignId',
    },
    {
        name: 'Дата создания',
        key: 'createdAt',
    },
    {
        name: 'Ошибка',
        key: 'errors',
    },
]

export default defineComponent({
    components: {
        TheInput,
        TheButton,
        FailedFetch,
        TheTable,
        TableScrollWrapper,
        Modal,
    },
    setup() {
        const notifications = useNotifications()
        const { havePermissions } = useAccount()

        const state = reactive({
            is_loading: false,
            limit: 50,
            data: null as any | null,
            //
            createdAtFrom: null as string | null,
            createdAtTo: null as string | null,
            invoiceNumber: null as string | null,
        })

        const data_state = reactive({
            sdt_orders: new DataState<SdtOrder>({}),
        })

        const loadSdt = async (page: number) => {
            data_state.sdt_orders.pagination.current_page = page
            const params = {
                page,
                limit: state.limit,
                //
                createdAtFrom: state.createdAtFrom,
                createdAtTo: state.createdAtTo,
                invoiceNumber: state.invoiceNumber,
                notCreated: 1,
            }

            try {
                data_state.sdt_orders.is_loading = true
                const response = await onec.getSdtOrders(params)

                data_state.sdt_orders.list = response.data
                data_state.sdt_orders.pagination.total_pages = response.meta.last_page

                data_state.sdt_orders.is_failed = false
                data_state.sdt_orders.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.sdt_orders.failure.catchError(error)

                if (!data_state.sdt_orders.failure.error_state.is_cancel) {
                    data_state.sdt_orders.is_failed = true
                }
            } finally {
                if (!data_state.sdt_orders.failure.error_state.is_cancel) {
                    data_state.sdt_orders.is_loading = false
                }
            }
        }

        const onLimitChange = (limit: number) => {
            state.limit = limit
            loadSdt(data_state.sdt_orders.pagination.current_page)
        }

        const reset = () => {
            state.createdAtFrom = null
            state.createdAtTo = null
            state.invoiceNumber = null

            loadSdt(1)
        }

        const getPayload = () => {
            return {
                createdAtFrom: state.createdAtFrom,
                createdAtTo: state.createdAtTo,
                invoiceNumber: state.invoiceNumber,
                notCreated: 1,
            }
        }

        const resend = async () => {
            try {
                state.is_loading = true
                await onec.resendSdt(getPayload())
                notifications.notify({ title: 'Заказы успешно прокинуты!', type: 'success' })
                reset()
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'Произошла ошибка',
                })
                console.error(error)
            } finally {
                state.is_loading = false
            }
        }

        const resendSdtOrder = async (id: number) => {
            try {
                state.is_loading = true
                await onec.resendSdtOrder(id)
                notifications.notify({ title: 'Заказ успешно переотправлен!', type: 'success' })
                loadSdt(1)
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'Произошла ошибка',
                })
                console.error(error)
            } finally {
                state.is_loading = false
            }
        }

        const toggleData = (data?: any) => {
            state.data = data || null
        }

        const formatDate = (dateStr: string) => {
            if (!dateStr) return '-'

            const dateFirst = dateStr.split(' ')[0]
            const dateSecond = dateStr.split(' ')[1]
            return dateFirst.split('-').reverse().join('.') + ' ' + dateSecond
        }

        onBeforeMount(() => loadSdt(1))

        return {
            state,
            data_state,
            resendSdtOrder,
            reset,
            loadSdt,
            SdtColumns,
            onLimitChange,
            toggleData,
            havePermissions,
            resend,
            formatDate,
        }
    },
})
